import instagram from './Icons/instagram.svg';
import gottem from './Icons/gottem.svg';
import { motion } from 'framer-motion';
import Navbar from './navbar.js';
import SiteCounter from './SiteCounter.js';

const P3 = ({ isPortrait }) => {

    // Animation variants for the text
    const textVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };

    // Animation variants for the symbol-text pair
    const symbolTextPairVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { delay: 0.5 } }, // Delayed to start after text
    };

    const GoToInsta = () => {
        window.open('https://www.instagram.com/yume_wo_katare/', '_blank');
    };

    const v1 = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };

    // Animation variants for the symbol-text pair
    const v2 = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { delay: 0.5 } }, // Delayed to start after text
    };

    const v3 = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { delay: 1 } }, // Delayed to start after text
    };


    return (
        <div className='layout'>
            <div className='title' />
            <SiteCounter />
            <div className={`content-center ${isPortrait ? '' : 'content-center-landscape'}`}>

                <motion.div
                    initial="hidden"
                    animate="visible"
                    variants={v1}
                    transition={{ duration: 0.5 }}
                    className={` ${isPortrait ? '' : 'p3-content-landscape'}`}
                    style={{marginBottom:'50px', marginTop:'30px'}}
                >
                    <h1>Menu</h1>
                    <h4 className='hours'>Special Pork Ramen</h4>
                </motion.div>
                <motion.div
                    initial="hidden"
                    animate="visible"
                    variants={v2}
                    transition={{ duration: 0.5 }}
                    className={` ${isPortrait ? '' : 'p3-content-landscape'}`}
                    style={{marginBottom:'30px'}}
                >
                    <h1>Don't wait in line</h1>
                    <h4 className='hours'>Off-peak hours</h4>
                    <h4 className='hours'>4:30-6pm</h4>
                    <h4 className='hours'>8-9:30pm</h4>
                </motion.div>
                <motion.div
                    initial="hidden"
                    animate="visible"
                    variants={v3}
                    className={`symbol-text-pair ${isPortrait ? '' : 'p3-content-landscape'}`}
                    style={{ marginRight:'50px'}}>
                    <motion.div whileTap={{ scale: 0.6 }} transition={{ duration: 0.3 }} onClick={(e) => GoToInsta()}>
                        <img className='icon' src={instagram} alt="Phone" />
                    </motion.div>

                    <img className='icon' src={gottem} alt="" />


                </motion.div>
            </div>


            <Navbar isPortrait={isPortrait} />
        </div>

    );
};

export default P3;
